// saml-client/translations.ts
var samlFederationTranslations = {
  samlFederation: {
    login: ["Login \xFCber ", "Login via "],
    buttonNoSelectedInstitution: ["Zum Einloggen Institution ausw\xE4hlen", "Select an institution to log in"],
    selectInitial: ["Institution zum Einloggen ausw\xE4hlen", "Select an institution to log in to"],
    selectAnother: ["Mit anderer Institution einloggen", "Login with another institution"],
    selectInstitution: ["Institution ausw\xE4hlen", "Select institution"],
    cancel: ["Abbrechen", "Cancel"]
  }
};
export {
  samlFederationTranslations
};
